export const translations = {
  en: {
    // Auth
    login: 'Login',
    email: 'Email',
    password: 'Password',
    loginButton: 'Sign In',
    logout: 'Logout',
    invalidCredentials: 'Invalid email or password',
    
    // Navigation
    home: 'Home',
    sendParcel: 'Send Parcel',
    receiveParcel: 'Receive Parcel',
    lockerMap: 'Locker Map',
    myLog: 'My Log',
    timeline: 'Timeline',
    admin: 'Admin',
    whiteLabel: 'White Label',
    branded: 'Branded',
    
    // Home
    welcomeTo: 'Welcome to',
    smartSecure: 'Smart, secure, and convenient parcel management for employees and clients. Access your locker 24/7 with PIN or RFID badge.',
    startDeposit: 'Start Deposit',
    startRetrieval: 'Start Retrieval',
    depositYourPackage: 'Deposit your package in an available locker',
    retrieveYourPackage: 'Retrieve your package using PIN or RFID badge',
    lockerStatus: 'Locker Status',
    availableLockers: 'Available lockers',
    viewMap: 'View Map',
    realTimeActivity: 'Real-time activity',
    viewTimeline: 'View Timeline',
    howItWorks: 'How It Works',
    aboutDemo: 'About This Demo',
    aboutText: 'This is an interactive frontend simulation of the {brand} system. All data is stored locally in your browser. You can deposit parcels, retrieve them with PIN or RFID, monitor locker status in real-time, and explore the admin panel for advanced scenarios.',
    
    // Deposit Flow
    followSteps: 'Follow the steps to deposit your package',
    chooseLockerSize: 'Choose Locker Size',
    selectSize: 'Select the size that fits your parcel',
    small: 'Small',
    medium: 'Medium',
    large: 'Large',
    documentsSmallItems: 'Documents, small items',
    boxesPackages: 'Boxes, packages',
    largeParcels: 'Large parcels, bags',
    noLockers: 'No lockers available',
    selectRecipient: 'Select recipient',
    generateYourPin: 'Generate Your PIN',
    needPinRetrieve: "You'll need this PIN to retrieve your parcel",
    yourName: 'Your Name',
    toWhom: 'To Whom',
    generatePin: 'Generate PIN',
    backToSizeSelection: 'Back to Size Selection',
    yourPinCode: 'Your PIN Code',
    savePinRetrieve: "Save this PIN - you'll need it to retrieve your parcel",
    simulateDrop: 'Simulate Drop',
    cancel: 'Cancel',
    depositSuccessful: 'Deposit Successful!',
    parcelSecured: 'Your parcel has been securely stored',
    lockerNumber: 'Locker Number',
    yourPin: 'Your PIN',
    depositAnother: 'Deposit Another Parcel',
    backToHome: 'Back to Home',
    
    // Retrieve Flow
    chooseAuthMethod: 'Choose your authentication method',
    enterPin: 'Enter PIN',
    usePinCode: 'Use your 4-6 digit PIN code to open the locker',
    openKeypad: 'Open Keypad',
    rfidBadge: 'RFID Badge',
    tapBadge: 'Tap your employee badge to access your locker',
    simulateRfid: 'Simulate RFID Tap',
    retrievalSuccessful: 'Retrieval successful',
    invalidPin: 'Invalid PIN',
    pinDoesNotMatch: 'The PIN you entered does not match any of your parcels',
    noParcels: 'No parcels',
    noParcelToRetrieve: 'You have no parcels to retrieve',
    openedViaRfid: 'opened via RFID badge',
    myParcels: 'My Parcels',
    parcelsForYou: 'Parcels destined for you',
    parcel: 'parcel',
    forYou: 'for you',
    noParcelForYou: 'No parcels waiting for you',
    enterYourPin: 'Enter Your PIN',
    parcelsReady: 'These lockers have parcels ready for retrieval',
    lockerOpened: 'Locker Opened!',
    collectParcel: 'Please collect your parcel',
    retrieveAnother: 'Retrieve Another Parcel',
    
    // Locker Map
    realTimeStatus: 'Real-time status of all lockers',
    freeLockers: 'Free Lockers',
    occupiedLockers: 'Occupied Lockers',
    alerts: 'Alerts',
    availableForUse: 'Available for use',
    currentlyInUse: 'Currently in use',
    requireAttention: 'Require attention',
    lockerGrid: 'Locker Grid',
    clickForDetails: 'Click on any locker to view details and simulate actions',
    legend: 'Legend',
    freeAvailable: 'Free - Available for deposit',
    occupiedContains: 'Occupied - Contains parcel',
    alertRequired: 'Alert - Requires attention',
    
    // My Log
    myActivity: 'My Activity',
    trackParcels: 'Track your sent and received parcels',
    sent: 'Sent',
    received: 'Received',
    parcelsSent: 'Parcels you sent to others',
    parcelsReceived: 'Parcels you received from others',
    exportCsv: 'Export CSV',
    noActivity: 'No activity yet',
    
    // Admin Panel
    adminPanel: 'Admin Panel',
    manageUsers: 'Manage users, logs, and system settings',
    totalLockers: 'Total Lockers',
    activeLockers: 'Active Lockers',
    totalEvents: 'Total Events',
    unitsTotal: 'units total',
    currentlyOccupied: 'Currently occupied',
    allTimeActivity: 'All time activity',
    logs: 'Logs',
    usersBadges: 'Users & Badges',
    simulation: 'Simulation',
    settings: 'Settings',
    eventLogs: 'Event Logs',
    viewFilterActivity: 'View and filter all locker activity',
    eventType: 'Event Type',
    locker: 'Locker',
    allLockers: 'All Lockers',
    time: 'Time',
    type: 'Type',
    user: 'User',
    details: 'Details',
    showing: 'Showing',
    of: 'of',
    events: 'events',
    manageDemoUsers: 'Manage demo users and RFID badges',
    rfidActive: 'RFID Active',
    pinOnly: 'PIN Only',
    simulationControls: 'Simulation Controls',
    runPredefined: 'Run predefined scenarios and manage demo data',
    playFullDay: 'Play Full Day Scenario',
    fullDayDesc: 'This will replay a predefined sequence of 16 events simulating a full day of locker activity. Navigate to the Timeline page to watch the playback.',
    resetDemo: 'Reset Demo Data',
    resetWarning: 'Warning: This will clear all current locker states and logs, resetting to initial demo data.',
    themeSettings: 'Theme Settings',
    customizeAppearance: 'Customize the appearance of the system',
    whiteLabelMode: 'White Label Mode',
    switchNeutral: 'Switch to neutral branding',
    switchToSwedbank: 'Switch to Swedbank',
    switchToWhiteLabel: 'Switch to White Label',
    currentTheme: 'Current Theme',
    brandName: 'Brand Name',
    primaryColor: 'Primary Color',
    whiteLabelTip: 'White label mode is perfect for demos to clients who want to see the system without specific branding.',
    
    // Timeline
    viewActivityHistory: 'View activity history and replay scenarios',
    scenarioPlayback: 'Scenario Playback',
    replayFullDay: 'Replay a full day simulation with 16 events',
    event: 'Event',
    speed: 'Speed',
    playScenario: 'Play Scenario',
    pause: 'Pause',
    replay: 'Replay',
    eventHistory: 'Event History',
    chronologicalOrder: 'All locker activity in chronological order',
    noEventsYet: 'No events yet',
    
    // Common
    size: 'Size',
    status: 'Status',
    free: 'Free',
    occupied: 'Occupied',
    alert: 'Alert',
    dropOff: 'Drop-Off',
    deposit: 'Deposit',
    retrieve: 'Retrieve',
    tamper: 'Tamper',
    batteryLow: 'Battery-low',
    method: 'Method',
    pin: 'PIN',
    rfid: 'RFID',
    action: 'Action',
    currentUser: 'Current User',
    demoOnly: 'Demo Only - All data stored locally',
    interactiveSimulation: 'Interactive simulation for presentation purposes',
    live: 'Live',
    from: 'From',
    to: 'To',
    exp: 'EXP',
    na: 'N/A',
    
    // Additional Deposit strings
    available: 'available',
    sorryAllLockers: 'Sorry, all {size} lockers are currently occupied.',
    pleaseSelectRecipient: 'Please select a recipient',
    
    // Login page
    selectAccount: 'Select your account to continue',
    demoMode: 'Demo Mode',
    clickAnyUser: 'Click any user to login instantly (no password required)',
    
    // Lockers page
    cannotDeposit: 'Cannot deposit',
    lockerNotAvailable: 'This locker is not available.',
    dropSimulated: 'Drop simulated',
    parcelDepositedInLocker: 'Parcel deposited in locker #{locker}. PIN: {pin}',
    cannotRetrieve: 'Cannot retrieve',
    lockerIsEmpty: 'This locker is empty.',
    retrievalSimulated: 'Retrieval simulated',
    lockerNowFree: 'Locker #{locker} is now free.',
    tamperAlert: 'Tamper alert',
    tamperDetected: 'Tamper detected on locker #{locker}',
    batteryAlert: 'Battery alert',
    lowBatteryDetected: 'Low battery detected on locker #{locker}',
    manageSimulateActions: 'Manage and simulate locker actions',
    simulateDrop: 'Simulate Drop',
    simulateRetrieve: 'Simulate Retrieve',
    simulateTamper: 'Simulate Tamper',
    simulateBatteryLow: 'Simulate Battery Low',
    
    // Timeline page
    timeline: 'Timeline',
    viewActivityHistory: 'View activity history and replay scenarios',
    scenarioPlayback: 'Scenario Playback',
    replayFullDay: 'Replay a full day simulation with 16 events',
    event: 'Event',
    speed: 'Speed',
    playScenario: 'Play Scenario',
    pause: 'Pause',
    replay: 'Replay',
    eventHistory: 'Event History',
    chronologicalOrder: 'All locker activity in chronological order',
    noEventsYet: 'No events yet',
    scenarioComplete: 'Scenario complete',
    allEventsReplayed: 'All events have been replayed.',
    eventCount: 'Event {current} / {total}',
    speedValue: 'Speed: {speed}×',
    
    // Admin Panel
    adminPanel: 'Admin Panel',
    manageUsers: 'Manage users, logs, and system settings',
    totalLockers: 'Total Lockers',
    activeLockers: 'Active Lockers',
    totalEvents: 'Total Events',
    unitsTotal: 'units total',
    currentlyOccupied: 'Currently occupied',
    allTimeActivity: 'All time activity',
    logs: 'Logs',
    usersBadges: 'Users & Badges',
    simulation: 'Simulation',
    settings: 'Settings',
    eventLogs: 'Event Logs',
    viewFilterActivity: 'View and filter all locker activity',
    eventType: 'Event Type',
    locker: 'Locker',
    allLockers: 'All Lockers',
    time: 'Time',
    type: 'Type',
    user: 'User',
    details: 'Details',
    showing: 'Showing',
    of: 'of',
    events: 'events',
    manageDemoUsers: 'Manage demo users and RFID badges',
    rfidActive: 'RFID Active',
    pinOnly: 'PIN Only',
    simulationControls: 'Simulation Controls',
    runPredefined: 'Run predefined scenarios and manage demo data',
    playFullDay: 'Play Full Day Scenario',
    fullDayDesc: 'This will replay a predefined sequence of 16 events simulating a full day of locker activity. Navigate to the Timeline page to watch the playback.',
    resetDemo: 'Reset Demo Data',
    resetWarning: 'Warning: This will clear all current locker states and logs, resetting to initial demo data.',
    themeSettings: 'Theme Settings',
    customizeAppearance: 'Customize the appearance of the system',
    whiteLabelMode: 'White Label Mode',
    switchNeutral: 'Switch to neutral branding',
    switchToSwedbank: 'Switch to Swedbank',
    switchToWhiteLabel: 'Switch to White Label',
    currentTheme: 'Current Theme',
    brandName: 'Brand Name',
    primaryColor: 'Primary Color',
    whiteLabelTip: 'White label mode is perfect for demos to clients who want to see the system without specific branding.',
    areYouSureReset: 'Are you sure you want to reset all demo data? This cannot be undone.',
    demoReset: 'Demo reset',
    allDataReset: 'All data has been reset to initial state.',
    scenarioStarted: 'Scenario started',
    navigateToTimeline: 'Navigate to Timeline page to watch the playback.',
    exportSuccessful: 'Export successful',
    logsExported: 'Logs have been exported to CSV file.',
    exportCsv: 'Export CSV',
    requireAttention: 'Require attention',
    
    // CSV Export Headers
    csvId: 'ID',
    csvTimestamp: 'Timestamp',
    csvType: 'Type',
    csvLocker: 'Locker',
    csvFromTo: 'From/To',
    csvDetails: 'Details',
  },
  
  lv: {
    // Auth
    login: 'Pieteikties',
    email: 'E-pasts',
    password: 'Parole',
    loginButton: 'Ieiet',
    logout: 'Iziet',
    invalidCredentials: 'Nepareizs e-pasts vai parole',
    
    // Navigation
    home: 'Sākums',
    sendParcel: 'Nosūtīt sūtījumu',
    receiveParcel: 'Saņemt sūtījumu',
    lockerMap: 'Skapīšu karte',
    myLog: 'Mans Žurnāls',
    timeline: 'Laika skala',
    admin: 'Administrācija',
    whiteLabel: 'Baltā etiķete',
    branded: 'Zīmols',
    
    // Home
    welcomeTo: 'Laipni lūdzam',
    smartSecure: 'Viedā, droša un ērtā sūtījumu pārvaldība darbiniekiem un klientiem. Piekļūstiet savam skapītim 24/7 ar PIN vai RFID karti.',
    startDeposit: 'Sākt noguldīšanu',
    startRetrieval: 'Sākt izņemšanu',
    depositYourPackage: 'Noguldiet savu sūtījumu pieejamā skapītī',
    retrieveYourPackage: 'Izņemiet savu sūtījumu, izmantojot PIN vai RFID karti',
    lockerStatus: 'Skapīšu statuss',
    availableLockers: 'Pieejamie skapīši',
    viewMap: 'Skatīt karti',
    realTimeActivity: 'Reāllaika aktivitāte',
    viewTimeline: 'Skatīt laika skalu',
    howItWorks: 'Kā tas darbojas',
    aboutDemo: 'Par Šo demo',
    aboutText: 'Šī ir interaktīva lietotāja saskarnes simulācija Swedbank Lockers sistēmai. Visi dati tiek glabāti lokāli jūsu pārlūkprogrammā. Jūs varat noguldīt sūtījumus, izņemt tos ar PIN vai RFID, uzraudzīt skapīšu statusu reāllaikā un izpētīt administrācijas paneli uzlabotiem scenārijiem.',
    
    // Deposit Flow
    followSteps: 'Sekojiet soļiem, lai noguldītu savu sūtījumu',
    chooseLockerSize: 'Izvēlieties skapīša izmēru',
    selectSize: 'Izvēlieties izmēru, kas atbilst jūsu sūtījumam',
    small: 'Mazs',
    medium: 'Vidējs',
    large: 'Liels',
    documentsSmallItems: 'Dokumenti, mazi priekšmeti',
    boxesPackages: 'Kastes, pakas',
    largeParcels: 'Lieli sūtījumi, somas',
    available: 'pieejams',
    generateYourPin: 'Ģenerējiet Savu PIN',
    needPinRetrieve: 'Jums būs nepieciešams šis PIN, lai izņemtu savu sūtījumu',
    yourName: 'Jūsu vārds',
    toWhom: 'Kam',
    generatePin: 'Ģenerēt PIN',
    backToSizeSelection: 'Atpakaļ uz izmēra izvēli',
    yourPinCode: 'Jūsu PIN kods',
    savePinRetrieve: 'Saglabājiet šo PIN - tas būs nepieciešams, lai izņemtu sūtījumu',
    simulateDrop: 'Simulēt noguldīšanu',
    cancel: 'Atcelt',
    depositSuccessful: 'Noguldīšana veiksmīga!',
    parcelSecured: 'Jūsu sūtījums ir droši uzglabāts',
    lockerNumber: 'Skapīša numurs',
    yourPin: 'Jūsu PIN',
    depositAnother: 'Noguldīt vēl vienu sūtījumu',
    backToHome: 'Atpakaļ uz sākumu',
    
    // Retrieve Flow
    chooseAuthMethod: 'Izvēlieties autentifikācijas metodi',
    enterPin: 'Ievadiet PIN',
    usePinCode: 'Izmantojiet savu 4-6 ciparu PIN kodu, lai atvērtu skapīti',
    openKeypad: 'Atvērt tastatūru',
    rfidBadge: 'RFID Karte',
    tapBadge: 'Pieskarieties ar savu darbinieka karti, lai piekļūtu skapītim',
    simulateRfid: 'Simulēt RFID pieskārienu',
    currentlyOccupied: 'Pašlaik aizņemtie skapīši',
    parcelsReady: 'Šajos skapīšos ir sūtījumi, kas gatavi izņemšanai',
    lockerOpened: 'Skapītis atvērts!',
    collectParcel: 'Lūdzu, paņemiet savu sūtījumu',
    retrieveAnother: 'Izņemt vēl vienu sūtījumu',
    
    // Retrieve Flow (additional)
    retrievalSuccessful: 'Izņemšana veiksmīga',
    invalidPin: 'Nepareizs PIN',
    pinDoesNotMatch: 'Ievadītais PIN neatbilst nevienam no jūsu sūtījumiem',
    noParcels: 'Nav sūtījumu',
    noParcelToRetrieve: 'Jums nav sūtījumu, ko izņemt',
    openedViaRfid: 'atvērts ar RFID karti',
    myParcels: 'Mani sūtījumi',
    parcelsForYou: 'Sūtījumi, kas paredzēti jums',
    parcel: 'sūtījums',
    forYou: 'jums',
    noParcelForYou: 'Jums nav gaida sūtījumu',
    enterYourPin: 'Ievadiet savu PIN',
    parcelsReady: 'Šajos skapīšos ir sūtījumi, kas gatavi izņemšanai',
    lockerOpened: 'Skapītis atvērts!',
    collectParcel: 'Lūdzu, paņemiet savu sūtījumu',
    retrieveAnother: 'Izņemt vēl vienu sūtījumu',
    
    // Locker Map (additional)
    realTimeStatus: 'Reāllaika statuss visiem skapīšiem',
    freeLockers: 'Brīvie skapīši',
    occupiedLockers: 'Aizņemtie skapīši',
    alerts: 'Brīdinājumi',
    availableForUse: 'Pieejams lietošanai',
    currentlyInUse: 'Pašlaik lietošanā',
    requireAttention: 'Nepieciešama uzmanība',
    lockerGrid: 'Skapīšu tīkls',
    clickForDetails: 'Noklikšķiniet uz jebkura skapīša, lai skatītu detaļas un simulētu darbības',
    legend: 'Apzīmējumi',
    freeAvailable: 'Brīvs - Pieejams noguldīšanai',
    occupiedContains: 'Aizņemts - Satur sūtījumu',
    alertRequired: 'Brīdinājums - Nepieciešama uzmanība',
    
    // My Log (additional)
    myActivity: 'Mana aktivitāte',
    trackParcels: 'Izsekojiet nosūtītajiem un saņemtajiem sūtījumiem',
    sent: 'Nosūtīti',
    received: 'Saņemti',
    parcelsSent: 'Sūtījumi, ko jūs nosūtījāt citiem',
    parcelsReceived: 'Sūtījumi, ko jūs saņēmāt no citiem',
    exportCsv: 'Eksportēt CSV',
    noActivity: 'Vēl nav aktivitātes',
    
    // Common
    size: 'Izmērs',
    status: 'Statuss',
    free: 'Brīvs',
    occupied: 'Aizņemts',
    alert: 'Brīdinājums',
    dropOff: 'Nodošana',
    deposit: 'Noguldīt',
    retrieve: 'Izņemt',
    tamper: 'Izjaukšana',
    batteryLow: 'Zems akumulators',
    method: 'Metode',
    pin: 'PIN',
    rfid: 'RFID',
    action: 'Darbība',
    currentUser: 'Pašreizējais lietotājs',
    demoOnly: 'Tikai Demo - Visi dati glabājas lokāli',
    interactiveSimulation: 'Interaktīva simulācija prezentācijas nolūkiem',
    live: 'Tiešraide',
    from: 'No',
    to: 'Kam',
    exp: 'SŪT',
    na: 'N/P',
    
    // Additional Deposit strings
    available: 'pieejams',
    noLockers: 'Nav skapīšu',
    sorryAllLockers: 'Atvainojiet, visi {size} skapīši pašlaik ir aizņemti.',
    pleaseSelectRecipient: 'Lūdzu, izvēlieties saņēmēju',
    selectRecipient: 'Izvēlieties saņēmēju',
    
    // Login page
    selectAccount: 'Izvēlieties savu kontu, lai turpinātu',
    demoMode: 'Demo Režīms',
    clickAnyUser: 'Noklikšķiniet uz jebkura lietotāja, lai pieteiktos uzreiz (nav nepieciešama parole)',
    
    // Lockers page
    cannotDeposit: 'Nevar noguldīt',
    lockerNotAvailable: 'Šis skapītis nav pieejams.',
    dropSimulated: 'Noguldīšana simulēta',
    parcelDepositedInLocker: 'Sūtījums noguldīts skapītī #{locker}. PIN: {pin}',
    cannotRetrieve: 'Nevar izņemt',
    lockerIsEmpty: 'Šis skapītis ir tukšs.',
    retrievalSimulated: 'Izņemšana simulēta',
    lockerNowFree: 'Skapītis #{locker} tagad ir brīvs.',
    tamperAlert: 'Izjaukšanas brīdinājums',
    tamperDetected: 'Izjaukšana konstatēta skapītī #{locker}',
    batteryAlert: 'Akumulatora brīdinājums',
    lowBatteryDetected: 'Zems akumulators konstatēts skapītī #{locker}',
    manageSimulateActions: 'Pārvaldīt un simulēt skapīša darbības',
    simulateDrop: 'Simulēt Noguldīšanu',
    simulateRetrieve: 'Simulēt Izņemšanu',
    simulateTamper: 'Simulēt Izjaukšanu',
    simulateBatteryLow: 'Simulēt zemu akumulatoru',
    
    // Timeline page
    viewActivityHistory: 'Skatīt aktivitāšu vēsturi un atkārtot scenārijus',
    scenarioPlayback: 'Scenārija atskaņošana',
    replayFullDay: 'Atkārtot pilnas dienas simulāciju ar 16 notikumiem',
    event: 'Notikums',
    speed: 'Ātrums',
    playScenario: 'Atskaņot scenāriju',
    pause: 'Pauze',
    replay: 'Atkārtot',
    eventHistory: 'Notikumu vēsture',
    chronologicalOrder: 'Visa skapīšu aktivitāte hronoloģiskā secībā',
    noEventsYet: 'Vēl nav notikumu',
    scenarioComplete: 'Scenārijs pabeigts',
    allEventsReplayed: 'Visi notikumi ir atkārtoti.',
    eventCount: 'Notikums {current} / {total}',
    speedValue: 'Ātrums: {speed}×',
    
    // Admin Panel
    adminPanel: 'Administrācijas panelis',
    manageUsers: 'Pārvaldīt lietotājus, žurnālus un sistēmas iestatījumus',
    totalLockers: 'Kopā skapīši',
    activeLockers: 'Aktīvie skapīši',
    totalEvents: 'Kopā notikumi',
    unitsTotal: 'kopā vienības',
    currentlyOccupied: 'Pašlaik aizņemti',
    allTimeActivity: 'Visu laiku aktivitāte',
    logs: 'Žurnāli',
    usersBadges: 'Lietotāji un kartes',
    simulation: 'Simulācija',
    settings: 'Iestatījumi',
    eventLogs: 'Notikumu Žurnāli',
    viewFilterActivity: 'Skatīt un filtrēt visu skapīšu aktivitāti',
    eventType: 'Notikuma tips',
    locker: 'Skapītis',
    allLockers: 'Visi skapīši',
    time: 'Laiks',
    type: 'Tips',
    user: 'Lietotājs',
    details: 'Detaļas',
    showing: 'Rāda',
    of: 'no',
    events: 'notikumi',
    manageDemoUsers: 'Pārvaldīt demo lietotājus un RFID kartes',
    rfidActive: 'RFID Aktīvs',
    pinOnly: 'Tikai PIN',
    simulationControls: 'Simulācijas vadība',
    runPredefined: 'Palaist iepriekš definētus scenārijus un pārvaldīt demo datus',
    playFullDay: 'Atskaņot pilnas dienas scenāriju',
    fullDayDesc: 'Tas atkārtos iepriekš definētu 16 notikumu secību, simulējot pilnu dienas skapīšu aktivitāti. Dodieties uz Laika Skalas lapu, lai skatītu atskaņošanu.',
    resetDemo: 'Atiestatīt demo datus',
    resetWarning: 'Brīdinājums: Tas notīrīs visus pašreizējos skapīšu stāvokļus un žurnālus, atiestatot uz sākotnējiem demo datiem.',
    themeSettings: 'Tēmas Iestatījumi',
    customizeAppearance: 'Pielāgot sistēmas izskatu',
    whiteLabelMode: 'Baltās etiķetes režīms',
    switchNeutral: 'Pārslēgties uz neitrālu zīmolu',
    switchToSwedbank: 'Pārslēgties uz Swedbank',
    switchToWhiteLabel: 'Pārslēgties uz balto etiķeti',
    currentTheme: 'Pašreizējā tēma',
    brandName: 'Zīmola nosaukums',
    primaryColor: 'Primārā krāsa',
    whiteLabelTip: 'Baltās etiķetes režīms ir ideāli piemērots demonstrācijām klientiem, kuri vēlas redzēt sistēmu bez konkrēta zīmola.',
    areYouSureReset: 'Vai esat pārliecināts, ka vēlaties atiestatīt visus demo datus? To nevar atsaukt.',
    demoReset: 'Demo atiestatīts',
    allDataReset: 'Visi dati ir atiestatīti uz sākotnējo stāvokli.',
    scenarioStarted: 'Scenārijs sākts',
    navigateToTimeline: 'Dodieties uz Laika Skalas lapu, lai skatītu atskaņošanu.',
    exportSuccessful: 'Eksports veiksmīgs',
    logsExported: 'Žurnāli ir eksportēti uz CSV failu.',
    
    // CSV Export Headers
    csvId: 'ID',
    csvTimestamp: 'Laika zīmogs',
    csvType: 'Tips',
    csvLocker: 'Skapītis',
    csvFromTo: 'No/Kam',
    csvDetails: 'Detaļas',
  },
  
  lt: {
    // Auth
    login: 'Prisijungti',
    email: 'El. paštas',
    password: 'Slaptažodis',
    loginButton: 'Prisijungti',
    logout: 'Atsijungti',
    invalidCredentials: 'Neteisingas el. paštas arba slaptažodis',
    
    // Navigation
    home: 'Pradžia',
    sendParcel: 'Siųsti Siuntą',
    receiveParcel: 'Gauti Siuntą',
    lockerMap: 'Spintelių Žemėlapis',
    myLog: 'Mano Žurnalas',
    timeline: 'Laiko Juosta',
    admin: 'Administracija',
    whiteLabel: 'Balta Etiketė',
    branded: 'Prekės Ženklas',
    
    // Home
    welcomeTo: 'Sveiki atvykę į',
    smartSecure: 'Išmanusis, saugus ir patogus siuntų valdymas darbuotojams ir klientams. Prieiga prie spintelės 24/7 su PIN ar RFID kortele.',
    startDeposit: 'Pradėti Įdėjimą',
    startRetrieval: 'Pradėti Išėmimą',
    depositYourPackage: 'Įdėkite siuntą į laisvą spintelę',
    retrieveYourPackage: 'Išimkite siuntą naudojant PIN ar RFID kortelę',
    lockerStatus: 'Spintelių Būsena',
    availableLockers: 'Laisvos spintelės',
    viewMap: 'Žiūrėti Žemėlapį',
    realTimeActivity: 'Veikla realiuoju laiku',
    viewTimeline: 'Žiūrėti Laiko Juostą',
    howItWorks: 'Kaip Tai Veikia',
    aboutDemo: 'Apie Šią Demo',
    aboutText: 'Tai interaktyvi priekinės dalies {brand} sistemos simuliacija. Visi duomenys saugomi jūsų naršyklėje. Galite įdėti siuntas, išimti jas su PIN ar RFID, stebėti spintelių būseną realiuoju laiku ir tyrinėti administratoriaus skydelį.',
    
    // Deposit Flow
    followSteps: 'Sekite žingsnius, kad įdėtumėte siuntą',
    chooseLockerSize: 'Pasirinkite Spintelės Dydį',
    selectSize: 'Pasirinkite dydį, kuris tinka jūsų siuntai',
    small: 'Maža',
    medium: 'Vidutinė',
    large: 'Didelė',
    documentsSmallItems: 'Dokumentai, maži daiktai',
    boxesPackages: 'Dėžės, paketai',
    largeParcels: 'Didelės siuntos, krepšiai',
    available: 'laisva',
    noLockers: 'Nėra spintelių',
    selectRecipient: 'Pasirinkite gavėją',
    generateYourPin: 'Generuoti Jūsų PIN',
    needPinRetrieve: 'Jums reikės šio PIN, kad išimtumėte siuntą',
    yourName: 'Jūsų Vardas',
    toWhom: 'Kam',
    generatePin: 'Generuoti PIN',
    backToSizeSelection: 'Grįžti į Dydžio Pasirinkimą',
    yourPinCode: 'Jūsų PIN Kodas',
    savePinRetrieve: 'Išsaugokite šį PIN - jis bus reikalingas siuntai išimti',
    simulateDrop: 'Simuliuoti Įdėjimą',
    cancel: 'Atšaukti',
    depositSuccessful: 'Įdėjimas Sėkmingas!',
    parcelSecured: 'Jūsų siunta saugiai saugoma',
    lockerNumber: 'Spintelės Numeris',
    yourPin: 'Jūsų PIN',
    depositAnother: 'Įdėti Dar Vieną Siuntą',
    backToHome: 'Grįžti į Pradžią',
    
    // Retrieve Flow
    chooseAuthMethod: 'Pasirinkite autentifikavimo metodą',
    enterPin: 'Įveskite PIN',
    usePinCode: 'Naudokite 4-6 skaitmenų PIN kodą spintelei atidaryti',
    openKeypad: 'Atidaryti Klaviatūrą',
    rfidBadge: 'RFID Kortelė',
    tapBadge: 'Prisilieskite darbuotojo kortele, kad pasiektumėte spintelę',
    simulateRfid: 'Simuliuoti RFID Prisilietimą',
    retrievalSuccessful: 'Išėmimas sėkmingas',
    invalidPin: 'Neteisingas PIN',
    pinDoesNotMatch: 'Įvestas PIN neatitinka jūsų siuntų',
    noParcels: 'Nėra siuntų',
    noParcelToRetrieve: 'Neturite siuntų išimti',
    openedViaRfid: 'atidaryta per RFID kortelę',
    myParcels: 'Mano Siuntos',
    parcelsForYou: 'Siuntos skirtos jums',
    parcel: 'siunta',
    forYou: 'jums',
    noParcelForYou: 'Jūsų nelaukia jokių siuntų',
    enterYourPin: 'Įveskite Savo PIN',
    parcelsReady: 'Šiose spintelėse yra siuntų, paruoštų išėmimui',
    lockerOpened: 'Spintelė Atidaryta!',
    collectParcel: 'Prašome paimti siuntą',
    retrieveAnother: 'Išimti Dar Vieną Siuntą',
    
    // Locker Map
    realTimeStatus: 'Realiojo laiko būsena visų spintelių',
    freeLockers: 'Laisvos Spintelės',
    occupiedLockers: 'Užimtos Spintelės',
    alerts: 'Įspėjimai',
    availableForUse: 'Prieinama naudoti',
    currentlyInUse: 'Šiuo metu naudojama',
    requireAttention: 'Reikia dėmesio',
    lockerGrid: 'Spintelių Tinklas',
    clickForDetails: 'Spustelėkite bet kurią spintelę, kad pamatytumėte detales ir simuliuotumėte veiksmus',
    legend: 'Legenda',
    freeAvailable: 'Laisva - Prieinama įdėjimui',
    occupiedContains: 'Užimta - Yra siunta',
    alertRequired: 'Įspėjimas - Reikia dėmesio',
    
    // My Log
    myActivity: 'Mano Veikla',
    trackParcels: 'Sekite išsiųstas ir gautas siuntas',
    sent: 'Išsiųsta',
    received: 'Gauta',
    parcelsSent: 'Siuntos, kurias išsiuntėte kitiems',
    parcelsReceived: 'Siuntos, kurias gavote iš kitų',
    exportCsv: 'Eksportuoti CSV',
    noActivity: 'Dar nėra veiklos',
    
    // Admin Panel
    adminPanel: 'Administratoriaus Skydelis',
    manageUsers: 'Valdyti vartotojus, žurnalus ir sistemos nustatymus',
    totalLockers: 'Iš Viso Spintelių',
    activeLockers: 'Aktyvios Spintelės',
    totalEvents: 'Iš Viso Įvykių',
    unitsTotal: 'vienetų iš viso',
    currentlyOccupied: 'Šiuo metu užimta',
    allTimeActivity: 'Visų laikų veikla',
    logs: 'Žurnalai',
    usersBadges: 'Vartotojai ir Kortelės',
    simulation: 'Simuliacija',
    settings: 'Nustatymai',
    eventLogs: 'Įvykių Žurnalai',
    viewFilterActivity: 'Peržiūrėti ir filtruoti visą spintelių veiklą',
    eventType: 'Įvykio Tipas',
    locker: 'Spintelė',
    allLockers: 'Visos Spintelės',
    time: 'Laikas',
    type: 'Tipas',
    user: 'Vartotojas',
    details: 'Detalės',
    showing: 'Rodoma',
    of: 'iš',
    events: 'įvykiai',
    manageDemoUsers: 'Valdyti demo vartotojus ir RFID korteles',
    rfidActive: 'RFID Aktyvus',
    pinOnly: 'Tik PIN',
    simulationControls: 'Simuliacijos Valdymas',
    runPredefined: 'Paleisti iš anksto nustatytus scenarijus ir valdyti demo duomenis',
    playFullDay: 'Paleisti Visos Dienos Scenarijų',
    fullDayDesc: 'Tai atkartoja iš anksto nustatytą 16 įvykių seką, simuliuojančią visos dienos spintelių veiklą. Eikite į Laiko Juostos puslapį, kad žiūrėtumėte atkūrimą.',
    resetDemo: 'Atstatyti Demo Duomenis',
    resetWarning: 'Įspėjimas: Tai išvalys visas dabartines spintelių būsenas ir žurnalus, atstatant į pradinius demo duomenis.',
    themeSettings: 'Temos Nustatymai',
    customizeAppearance: 'Tinkinti sistemos išvaizdą',
    whiteLabelMode: 'Baltos Etiketės Režimas',
    switchNeutral: 'Perjungti į neutralų prekės ženklą',
    switchToSwedbank: 'Perjungti į Swedbank',
    switchToWhiteLabel: 'Perjungti į Baltą Etiketę',
    currentTheme: 'Dabartinė Tema',
    brandName: 'Prekės Ženklo Pavadinimas',
    primaryColor: 'Pagrindinė Spalva',
    whiteLabelTip: 'Baltos etiketės režimas puikiai tinka demo klientams, kurie nori matyti sistemą be konkretaus prekės ženklo.',
    areYouSureReset: 'Ar tikrai norite atstatyti visus demo duomenis? To negalima atšaukti.',
    demoReset: 'Demo atstatyta',
    allDataReset: 'Visi duomenys buvo atstatyti į pradinę būseną.',
    scenarioStarted: 'Scenarijus pradėtas',
    navigateToTimeline: 'Eikite į Laiko Juostos puslapį, kad žiūrėtumėte atkūrimą.',
    exportSuccessful: 'Eksportas sėkmingas',
    logsExported: 'Žurnalai buvo eksportuoti į CSV failą.',
    
    // Timeline
    viewActivityHistory: 'Peržiūrėti veiklos istoriją ir atkartoti scenarijus',
    scenarioPlayback: 'Scenarijaus Atkūrimas',
    replayFullDay: 'Atkartoti visos dienos simuliaciją su 16 įvykių',
    event: 'Įvykis',
    speed: 'Greitis',
    playScenario: 'Paleisti Scenarijų',
    pause: 'Pauzė',
    replay: 'Atkartoti',
    eventHistory: 'Įvykių Istorija',
    chronologicalOrder: 'Visa spintelių veikla chronologine tvarka',
    noEventsYet: 'Dar nėra įvykių',
    scenarioComplete: 'Scenarijus baigtas',
    allEventsReplayed: 'Visi įvykiai buvo atkartoti.',
    eventCount: 'Įvykis {current} / {total}',
    speedValue: 'Greitis: {speed}×',
    
    // Common
    size: 'Dydis',
    status: 'Būsena',
    free: 'Laisva',
    occupied: 'Užimta',
    alert: 'Įspėjimas',
    small: 'Maža',
    medium: 'Vidutinė',
    large: 'Didelė',
    deposit: 'Įdėti',
    retrieve: 'Išimti',
    pin: 'PIN',
    rfid: 'RFID',
    dropOff: 'Pristatymas',
    tamper: 'Kišimasis',
    batteryLow: 'Žema Baterija',
    method: 'Metodas',
    action: 'Veiksmas',
    currentUser: 'Dabartinis Vartotojas',
    demoOnly: 'Tik Demo - Visi duomenys saugomi vietoje',
    interactiveSimulation: 'Interaktyvi simuliacija pristatymui',
    live: 'Tiesiogiai',
    from: 'Nuo',
    to: 'Kam',
    exp: 'SIU',
    na: 'N/D',
    
    // Additional strings
    sorryAllLockers: 'Atsiprašome, visos {size} spintelės šiuo metu užimtos.',
    pleaseSelectRecipient: 'Prašome pasirinkti gavėją',
    selectAccount: 'Pasirinkite savo paskyrą, kad tęstumėte',
    demoMode: 'Demo Režimas',
    clickAnyUser: 'Spustelėkite bet kurį vartotoją, kad prisijungtumėte iš karto (nereikia slaptažodžio)',
    cannotDeposit: 'Negalima įdėti',
    lockerNotAvailable: 'Ši spintelė nepasiekiama.',
    dropSimulated: 'Įdėjimas simuliuotas',
    parcelDepositedInLocker: 'Siunta įdėta į spintelę #{locker}. PIN: {pin}',
    cannotRetrieve: 'Negalima išimti',
    lockerIsEmpty: 'Ši spintelė tuščia.',
    retrievalSimulated: 'Išėmimas simuliuotas',
    lockerNowFree: 'Spintelė #{locker} dabar laisva.',
    tamperAlert: 'Kišimosi įspėjimas',
    tamperDetected: 'Kišimasis aptiktas spintelėje #{locker}',
    batteryAlert: 'Baterijos įspėjimas',
    lowBatteryDetected: 'Žema baterija aptikta spintelėje #{locker}',
    manageSimulateActions: 'Valdyti ir simuliuoti spintelės veiksmus',
    simulateDrop: 'Simuliuoti Įdėjimą',
    simulateRetrieve: 'Simuliuoti Išėmimą',
    simulateTamper: 'Simuliuoti Kišimąsi',
    simulateBatteryLow: 'Simuliuoti Žemą Bateriją',
    csvId: 'ID',
    csvTimestamp: 'Laiko Žyma',
    csvType: 'Tipas',
    csvLocker: 'Spintelė',
    csvFromTo: 'Nuo/Kam',
    csvDetails: 'Detalės',
  },
  
  ee: {
    // Auth
    login: 'Logi sisse',
    email: 'E-post',
    password: 'Parool',
    loginButton: 'Sisene',
    logout: 'Logi välja',
    invalidCredentials: 'Vale e-post või parool',
    
    // Navigation
    home: 'Avaleht',
    sendParcel: 'Saada Pakk',
    receiveParcel: 'Võta Pakk Vastu',
    lockerMap: 'Kappide Kaart',
    myLog: 'Minu Logi',
    timeline: 'Ajatelg',
    admin: 'Admin',
    whiteLabel: 'Valge Silt',
    branded: 'Bränd',
    
    // Home
    welcomeTo: 'Tere tulemast',
    smartSecure: 'Nutikas, turvaline ja mugav pakkide haldamine töötajatele ja klientidele. Juurdepääs kapile 24/7 PIN-i või RFID kaardiga.',
    startDeposit: 'Alusta Hoiustamist',
    startRetrieval: 'Alusta Väljastamist',
    depositYourPackage: 'Pane oma pakk vabasse kappi',
    retrieveYourPackage: 'Võta oma pakk välja PIN-i või RFID kaardiga',
    lockerStatus: 'Kappide Olek',
    availableLockers: 'Vabad kapid',
    viewMap: 'Vaata Kaarti',
    realTimeActivity: 'Reaalajas tegevus',
    viewTimeline: 'Vaata Ajajoont',
    howItWorks: 'Kuidas See Toimib',
    aboutDemo: 'Sellest Demot',
    aboutText: 'See on interaktiivne esiotsa {brand} süsteemi simulatsioon. Kõik andmed salvestatakse teie brauseris kohalikult. Saate hoiustada pakke, võtta neid välja PIN-i või RFID-ga, jälgida kappide olekut reaalajas ja uurida admin paneeli.',
    
    // Deposit Flow
    followSteps: 'Järgi samme, et hoiustada oma pakk',
    chooseLockerSize: 'Vali Kapi Suurus',
    selectSize: 'Vali suurus, mis sobib sinu pakile',
    small: 'Väike',
    medium: 'Keskmine',
    large: 'Suur',
    documentsSmallItems: 'Dokumendid, väikesed asjad',
    boxesPackages: 'Kastid, paketid',
    largeParcels: 'Suured pakid, kotid',
    available: 'saadaval',
    noLockers: 'Kappe pole',
    selectRecipient: 'Vali saaja',
    generateYourPin: 'Genereeri Oma PIN',
    needPinRetrieve: 'Vajad seda PIN-i, et oma pakk välja võtta',
    yourName: 'Sinu Nimi',
    toWhom: 'Kellele',
    generatePin: 'Genereeri PIN',
    backToSizeSelection: 'Tagasi Suuruse Valimisele',
    yourPinCode: 'Sinu PIN Kood',
    savePinRetrieve: 'Salvesta see PIN - vajad seda paki välja võtmiseks',
    simulateDrop: 'Simuleeri Hoiustamist',
    cancel: 'Tühista',
    depositSuccessful: 'Hoiustamine Õnnestus!',
    parcelSecured: 'Sinu pakk on turvaliselt hoiul',
    lockerNumber: 'Kapi Number',
    yourPin: 'Sinu PIN',
    depositAnother: 'Hoiusta Veel Üks Pakk',
    backToHome: 'Tagasi Avalehele',
    
    // Retrieve Flow
    chooseAuthMethod: 'Vali autentimise meetod',
    enterPin: 'Sisesta PIN',
    usePinCode: 'Kasuta oma 4-6 numbrilist PIN-i koodi kapi avamiseks',
    openKeypad: 'Ava Klaviatuur',
    rfidBadge: 'RFID Kaart',
    tapBadge: 'Puuduta oma töötaja kaardiga, et pääseda kapile juurde',
    simulateRfid: 'Simuleeri RFID Puudutust',
    retrievalSuccessful: 'Väljastamine õnnestus',
    invalidPin: 'Vale PIN',
    pinDoesNotMatch: 'Sisestatud PIN ei vasta ühelegi sinu pakile',
    noParcels: 'Pole pakke',
    noParcelToRetrieve: 'Sul pole pakke välja võtta',
    openedViaRfid: 'avatud RFID kaardiga',
    myParcels: 'Minu Pakid',
    parcelsForYou: 'Pakid sulle',
    parcel: 'pakk',
    forYou: 'sulle',
    noParcelForYou: 'Sind ei oota ühtegi pakki',
    enterYourPin: 'Sisesta Oma PIN',
    parcelsReady: 'Neis kappides on pakid, mis on valmis välja võtmiseks',
    lockerOpened: 'Kapp Avatud!',
    collectParcel: 'Palun võta oma pakk',
    retrieveAnother: 'Võta Välja Veel Üks Pakk',
    
    // Locker Map
    realTimeStatus: 'Kõikide kappide reaalajas olek',
    freeLockers: 'Vabad Kapid',
    occupiedLockers: 'Hõivatud Kapid',
    alerts: 'Hoiatused',
    availableForUse: 'Saadaval kasutamiseks',
    currentlyInUse: 'Praegu kasutuses',
    requireAttention: 'Vajab tähelepanu',
    lockerGrid: 'Kappide Võrk',
    clickForDetails: 'Kliki mis tahes kapil, et näha detaile ja simuleerida tegevusi',
    legend: 'Legend',
    freeAvailable: 'Vaba - Saadaval hoiustamiseks',
    occupiedContains: 'Hõivatud - Sisaldab pakki',
    alertRequired: 'Hoiatus - Vajab tähelepanu',
    
    // My Log
    myActivity: 'Minu Tegevus',
    trackParcels: 'Jälgi saadetud ja saadud pakke',
    sent: 'Saadetud',
    received: 'Saadud',
    parcelsSent: 'Pakid, mida saatsid teistele',
    parcelsReceived: 'Pakid, mida said teistelt',
    exportCsv: 'Ekspordi CSV',
    noActivity: 'Veel pole tegevust',
    
    // Admin Panel
    adminPanel: 'Administraatori Paneel',
    manageUsers: 'Halda kasutajaid, logisid ja süsteemi seadeid',
    totalLockers: 'Kokku Kappe',
    activeLockers: 'Aktiivsed Kapid',
    totalEvents: 'Kokku Sündmusi',
    unitsTotal: 'ühikut kokku',
    currentlyOccupied: 'Praegu hõivatud',
    allTimeActivity: 'Kogu aja tegevus',
    logs: 'Logid',
    usersBadges: 'Kasutajad ja Kaardid',
    simulation: 'Simulatsioon',
    settings: 'Seaded',
    eventLogs: 'Sündmuste Logid',
    viewFilterActivity: 'Vaata ja filtreeri kogu kappide tegevust',
    eventType: 'Sündmuse Tüüp',
    locker: 'Kapp',
    allLockers: 'Kõik Kapid',
    time: 'Aeg',
    type: 'Tüüp',
    user: 'Kasutaja',
    details: 'Detailid',
    showing: 'Näitan',
    of: '/st',
    events: 'sündmused',
    manageDemoUsers: 'Halda demo kasutajaid ja RFID kaarte',
    rfidActive: 'RFID Aktiivne',
    pinOnly: 'Ainult PIN',
    simulationControls: 'Simulatsiooni Juhtimine',
    runPredefined: 'Käivita eelseadistatud stsenaariumid ja halda demo andmeid',
    playFullDay: 'Mängi Terve Päeva Stsenaarium',
    fullDayDesc: 'See kordab eelseadistatud 16 sündmuse jada, simuleerides terve päeva kappide tegevust. Mine Ajajoone lehele, et vaadata taasesitust.',
    resetDemo: 'Lähtesta Demo Andmed',
    resetWarning: 'Hoiatus: See kustutab kõik praegused kappide olekud ja logid, lähtestades algsetele demo andmetele.',
    themeSettings: 'Teema Seaded',
    customizeAppearance: 'Kohanda süsteemi välimust',
    whiteLabelMode: 'Valge Sildi Režiim',
    switchNeutral: 'Lülitu neutraalsele brändile',
    switchToSwedbank: 'Lülitu Swedbankile',
    switchToWhiteLabel: 'Lülitu Valgele Sildile',
    currentTheme: 'Praegune Teema',
    brandName: 'Brändi Nimi',
    primaryColor: 'Peamine Värv',
    whiteLabelTip: 'Valge sildi režiim on ideaalne demo klientidele, kes tahavad näha süsteemi ilma konkreetse brändita.',
    areYouSureReset: 'Kas oled kindel, et tahad lähtestada kõik demo andmed? Seda ei saa tagasi võtta.',
    demoReset: 'Demo lähtestatud',
    allDataReset: 'Kõik andmed on lähtestatud algsesse olekusse.',
    scenarioStarted: 'Stsenaarium alustatud',
    navigateToTimeline: 'Mine Ajajoone lehele, et vaadata taasesitust.',
    exportSuccessful: 'Eksport õnnestus',
    logsExported: 'Logid on eksporditud CSV faili.',
    
    // Timeline
    viewActivityHistory: 'Vaata tegevuse ajalugu ja korda stsenaariumeid',
    scenarioPlayback: 'Stsenaariumi Taasesitus',
    replayFullDay: 'Korda terve päeva simulatsiooni 16 sündmusega',
    event: 'Sündmus',
    speed: 'Kiirus',
    playScenario: 'Mängi Stsenaarium',
    pause: 'Paus',
    replay: 'Korda',
    eventHistory: 'Sündmuste Ajalugu',
    chronologicalOrder: 'Kogu kappide tegevus kronoloogilises järjekorras',
    noEventsYet: 'Veel pole sündmusi',
    scenarioComplete: 'Stsenaarium lõpetatud',
    allEventsReplayed: 'Kõik sündmused on korratud.',
    eventCount: 'Sündmus {current} / {total}',
    speedValue: 'Kiirus: {speed}×',
    
    // Common
    size: 'Suurus',
    status: 'Olek',
    free: 'Vaba',
    occupied: 'Hõivatud',
    alert: 'Hoiatus',
    small: 'Väike',
    medium: 'Keskmine',
    large: 'Suur',
    deposit: 'Hoiustada',
    retrieve: 'Väljastada',
    pin: 'PIN',
    rfid: 'RFID',
    dropOff: 'Üleandmine',
    tamper: 'Sekkumine',
    batteryLow: 'Madal Patarei',
    method: 'Meetod',
    action: 'Tegevus',
    currentUser: 'Praegune Kasutaja',
    demoOnly: 'Ainult Demo - Kõik andmed salvestatud kohalikult',
    interactiveSimulation: 'Interaktiivne simulatsioon esitluse eesmärgil',
    live: 'Otse',
    from: 'Kellelt',
    to: 'Kellele',
    exp: 'SAATJA',
    na: 'Puudub',
    
    // Additional strings
    sorryAllLockers: 'Vabandust, kõik {size} kapid on praegu hõivatud.',
    pleaseSelectRecipient: 'Palun vali saaja',
    selectAccount: 'Vali oma konto jätkamiseks',
    demoMode: 'Demo Režiim',
    clickAnyUser: 'Kliki mis tahes kasutajal, et kohe sisse logida (parooli pole vaja)',
    cannotDeposit: 'Ei saa hoiustada',
    lockerNotAvailable: 'See kapp pole saadaval.',
    dropSimulated: 'Hoiustamine simuleeritud',
    parcelDepositedInLocker: 'Pakk hoiustatud kappi #{locker}. PIN: {pin}',
    cannotRetrieve: 'Ei saa välja võtta',
    lockerIsEmpty: 'See kapp on tühi.',
    retrievalSimulated: 'Väljastamine simuleeritud',
    lockerNowFree: 'Kapp #{locker} on nüüd vaba.',
    tamperAlert: 'Sekkumise hoiatus',
    tamperDetected: 'Sekkumine avastatud kapis #{locker}',
    batteryAlert: 'Patarei hoiatus',
    lowBatteryDetected: 'Madal patarei avastatud kapis #{locker}',
    manageSimulateActions: 'Halda ja simuleeri kapi tegevusi',
    simulateDrop: 'Simuleeri Hoiustamist',
    simulateRetrieve: 'Simuleeri Väljastamist',
    simulateTamper: 'Simuleeri Sekkumist',
    simulateBatteryLow: 'Simuleeri Madalat Patareid',
    csvId: 'ID',
    csvTimestamp: 'Ajatempel',
    csvType: 'Tüüp',
    csvLocker: 'Kapp',
    csvFromTo: 'Kellelt/Kellele',
    csvDetails: 'Detailid',
  }
};

export const getTranslation = (key, lang = 'en', replacements = {}) => {
  let text = translations[lang]?.[key] || translations.en[key] || key;
  
  // Replace placeholders like {brand}, {locker}, {pin}, etc.
  Object.keys(replacements).forEach(placeholder => {
    const regex = new RegExp(`\\{${placeholder}\\}`, 'g');
    text = text.replace(regex, replacements[placeholder]);
  });
  
  return text;
};
